import { render, staticRenderFns } from "./AccountsListCard.vue?vue&type=template&id=2b574071&scoped=true&"
import script from "./AccountsListCard.vue?vue&type=script&lang=js&"
export * from "./AccountsListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b574071",
  null
  
)

export default component.exports